<template>

<div class="group" v-if="count">

	<com-input v-for="input in recommendation.inputs" :key="input" :input="inputs[input]" />

</div>

</template>

<script>

import comInput from '@/components/tool/common/section/form/Input'

export default {

	props: ['recommendation'],

	components: {
		'com-input': comInput,
	},

	computed: {

		count: function() {

			var count = 0

			this.$_.each(this.recommendation.inputs, function(id) {

				if (this.visible(this.inputs[id])) {

					count++

				}

			}.bind(this))

			return count

		}

	}

}

</script>

<style scoped>

.is-mobile .group {
	padding-top: 16px;
}

</style>